import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from './Controller';
import { Days } from '../Commom/Days';
import { StyledCalendar } from '../Commom/index.styles';

export const Calendar = ({ onDecrease, onIncrease, onSelect, date, ...otherProps }) => {
    return (
        <StyledCalendar {...otherProps}>
            <Controller onDecrease={onDecrease} onIncrease={onIncrease} date={date} />
            <Days onSelect={onSelect} date={date} />
        </StyledCalendar>
    );
};

Calendar.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    onDecrease: PropTypes.string,
    onIncrease: PropTypes.string,
    onSelect: PropTypes.string,
    date: PropTypes.string,
};

/* istanbul ignore next */
Calendar.defaultProps = {
    width: '276px',
    height: '217px',
    onDecrease: '',
    onIncrease: '',
    onSelect: '',
    date: 'initialDate',
};
